<template>
  <div class="frameset">
    <!-- <div class="frameset-top" :style="{backgroundImage: 'linear-gradient( to right, '+topColor[0]+', '+topColor[1]+' 100%)'}" v-if="topColor.length==2">
    </div> -->
    <div class="frameset-body">
      <div class="logo-container">
        <div class="frameset-logo">
          <logoImg/>
        </div>
        <slot name="name"></slot>
        <slot name="hosticon"></slot>
        <slot name="divide"></slot>
        <slot name="subtitle"></slot>
      </div>
      <div class="dropdown-container">
        <slot name="dropdown-list"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import logoImg from '../assets/svg/icon_frameset_logo.svg'
export default {
  name: 'frameset',
  props: {
    topColor: {
      type: Array,
      required: true
    }
  },
  components: {
    logoImg
  },
  computed: {}
}
</script>
<style lang="scss">
@import '../assets/scss/variables.scss';
@import '../assets/scss/menu.scss';
.frameset {
  display: block;
  width: 100%;
  user-select: none;
  // background-color: #fff;
  // box-shadow: 0 4px 15px 0 rgba(24,28,252,0.10);
  >.frameset-body {
    display: flex;
    height: 60px;
    align-items: center;
    // border-bottom: #efeded 1px solid;
    >.logo-container {
      width: 50%;
      display: flex;
      height: 60px;
      align-items: center;
      >.frameset-logo {
        margin-left: 30px;
        width: 28px;
        height: 28px;
        background-size: cover;
      }
    }
    >.dropdown-container {
      width: 50%;
      height: 60px;
      padding-right: 0;
      text-align: right;
      .dropdown-list {
        margin: 15px 8px 0 0;
        line-height: 28px;
        list-style: none;
        display: flex;
        justify-content: flex-end;
        >.divide {
          width: 1px;
          height: 25px;
          border-radius: 100px;
          background-color: #3645AC;
          margin: 0 10px 0 25px;
          align-self: center;
        }
        ul {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Frameset.vue